import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from '@tcc/i18n';
import styles from './ErrorMessage.css';

function ErrorMessage({ message }) {
  return (
    <div className={styles.container} role="alert">
      <div className={styles.message}>{getMessage(message)}</div>
    </div>
  );
}

ErrorMessage.propTypes = {
  message: PropTypes.string,
};

export default ErrorMessage;
